module.exports = __webpack_public_path__ + "img/vertical-launching-silo.f6e6772a.png";